<template>
  <div ref="chartContainer" style="width: 100%; height: 100%;">
    <highcharts class="mt-4"
     :options="options" ref="aChart" style="width: 100%; height: 100%;"></highcharts>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'shiftwise',
  props: {
    thisMachines: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.chart = this.$refs.aChart.chart;
    this.createSeries();
    this.initResizeObserver();
  },
  data() {
    return {
      resizeObserver: null,
      chart: null,
      options: {
        chart: {
          type: 'column',
          style: {
            fontFamily: 'Poppins, sans-serif',
          },
        },
        title: {
          text: 'Shift Wise OPE (%)',
          style: {
            color: '',
          },
        },
        plotOptions: {
          series: {
            grouping: true,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: '{y}',
              style: {
                color: '#000000',
                textOutline: 'none',
                fontWeight: 'bold',
              },
            },
          },
        },
        legend: {
          enabled: true,
          align: 'center',
          verticalAlign: 'bottom',
          layout: 'horizontal',
          itemStyle: {
            color: '#333',
            fontWeight: 'bold',
          },
        },
        tooltip: {
          shared: true,
        },
        xAxis: {
          categories: [],
          labels: {
            rotation: -45,
            style: {
              color: '',
            },
          },
        },
        yAxis: [
          {
            title: {
              text: null,
            },
            labels: {
              style: {
                color: '',
              },
            },
          },
        ],
        series: [],
      },
    };
  },
  computed: {
    ...mapState('helper', ['isDark']),
    ...mapState('kpiDashboard', ['thisDate']),
  },
  methods: {

    initResizeObserver() {
      this.resizeObserver = new ResizeObserver(() => {
        this.reflowChart();
      });
      if (this.$refs.chartContainer) {
        this.resizeObserver.observe(this.$refs.chartContainer);
      }
    },
    reflowChart() {
      this.$nextTick(() => {
        const chartInstance = this.$refs.aChart?.chart;
        if (chartInstance && chartInstance.reflow) {
          chartInstance.reflow();
        }
      });
    },

    roundOff(val) {
      if (val || val === 0) {
        return Math.round((val + Number.EPSILON) * 100) / 100;
      }
      return 0;
    },
    createSeries() {
      const shiftColors = {
        'Shift A': '#3D519D',
        'Shift B': '#1CA4D7',
        'Shift C': '#5F4E94',
      };

      const dateShiftKeys = [
        ...new Set(this.thisMachines.map((m) => `${m.date} ${m.shift}`)),
      ];

      const machineNames = [
        ...new Set(this.thisMachines.map((m) => m.machinename)),
      ];

      const series = dateShiftKeys.map((key) => {
        const shift = key.substring(key.lastIndexOf(' ') + 1);
        const fullShift = `Shift ${shift}`;
        const data = machineNames.map((machine) => {
          const entry = this.thisMachines.find((m) => m.machinename === machine && `${m.date} ${m.shift}` === key);
          return {
            name: machine,
            y: entry ? this.roundOff(entry.a) : 0,
          };
        });

        return {
          name: key,
          data,
          color: shiftColors[fullShift] || '#999999',
        };
      });

      const targetData = machineNames.map((machine) => {
        const entry = this.thisMachines.find((m) => m.machinename === machine
        && m.targetLine !== undefined);
        return entry ? this.roundOff(entry.targetLine) : null;
      });

      if (targetData.some((v) => v !== null)) {
        series.unshift({
          name: 'Target',
          type: 'line',
          data: targetData,
          color: '#1CA4D7',
          dashStyle: 'ShortDash',
          zIndex: 5,
          marker: {
            enabled: true,
            radius: 3,
          },
          dataLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold',
              color: this.isDark ? '#FFFFFF' : '#000000',
            },
            formatter() {
              return this.y;
            },
          },
        });
      }

      this.options.xAxis.categories = machineNames;
      this.options.series = series;
      this.$nextTick(() => {
        this.reflowChart();
      });
    },
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },
  watch: {
    thisMachines: {
      deep: true,
      handler() {
        this.createSeries();
      },
    },
    isDark: {
      immediate: true,
      handler(val) {
        if (val) {
          this.options.title.style.color = '#FFFFFF';
          this.options.yAxis[0].labels.style.color = '#FFFFFF';
          this.options.xAxis.labels.style.color = '#FFFFFF';
          if (this.options.series[0]) {
            this.options.series[0].color = '#21C77C';
          }
        } else {
          this.options.title.style.color = '#333333';
          this.options.yAxis[0].labels.style.color = '#666666';
          this.options.xAxis.labels.style.color = '#666666';
          if (this.options.series[0]) {
            this.options.series[0].color = '#354493';
          }
        }
      },
    },
  },
};
</script>
